import { useTranslation } from 'react-i18next';

export default function Solutions() {
  const { t } = useTranslation();

  const solutions = [
    {
      icon: 'ri-tools-line',
      titleKey: 'solutions.ingenieria.titulo',
      descriptionKey: 'solutions.ingenieria.descripcion',
      features: [
        'solutions.ingenieria.feature1',
        'solutions.ingenieria.feature2',
        'solutions.ingenieria.feature3',
        'solutions.ingenieria.feature4'
      ]
    },
    {
      icon: 'ri-shield-check-line',
      titleKey: 'solutions.compliance.titulo',
      descriptionKey: 'solutions.compliance.descripcion',
      features: [
        'solutions.compliance.feature1',
        'solutions.compliance.feature2',
        'solutions.compliance.feature3',
        'solutions.compliance.feature4'
      ]
    },
    {
      icon: 'ri-money-euro-circle-line',
      titleKey: 'solutions.financiacion.titulo',
      descriptionKey: 'solutions.financiacion.descripcion',
      features: [
        'solutions.financiacion.feature1',
        'solutions.financiacion.feature2',
        'solutions.financiacion.feature3',
        'solutions.financiacion.feature4'
      ]
    }
  ];

  return (
    <section id="soluciones" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('solutions.titulo')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('solutions.subtitulo')}
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 mb-12">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${solution.icon} text-2xl text-teal-600`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t(solution.titleKey)}
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {t(solution.descriptionKey)}
              </p>

              <ul className="space-y-3">
                {solution.features.map((featureKey, featureIndex) => (
                  <li key={featureIndex} className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></div>
                    <span className="text-gray-700">{t(featureKey)}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Mensaje destacado */}
        <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-center shadow-xl">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
              {t('solutions.mensaje')}
            </h3>
            <p className="text-lg md:text-xl text-teal-50">
              {t('solutions.mensajeDestacado')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
